export default __webpack_public_path__ + "static/media/logo-seap.4d0a6bab.png";